// extracted by mini-css-extract-plugin
export default {"notification":"BNotificationCard_notification__zLbXv","body":"BNotificationCard_body__KunTb","content":"BNotificationCard_content__k4Yql"};